import { useViewport } from 'hooks/3catinfo/useViewport';
import Titol from 'components/3catinfo/Titol';
import Boto from 'components/3catinfo/Boto';
import clsx from 'clsx';
import styles from './meteodades.module.scss';
import Embed from 'components/3catinfo/Embed';

const Meteodades = (props) => {
    const { embed } = props;

    const { zoomNavigator } = useViewport();
    const styleMeteodades = clsx({
        [styles.contentMeteodades]: true,
        [styles.ambZoom]: zoomNavigator > 2.5
    });

    return (
        <div className={styleMeteodades} data-testid='meteodades'>
            <div className={styles.capcalera}>
                <div className={styles.contentTitol}>
                    <Titol tag='h2' titol='Meteodades' />
                    <p>
                        Aquest mapa mostra les dades recollides amb les <strong>estacions meteorològiques</strong> dels usuaris de
                        3Cat.{' '}
                    </p>
                </div>

                <Boto
                    novaFinestra={false}
                    type='web_3catinfo_el_temps_alta_estacio'
                    text="Dona d'alta la teva estació"
                    estil='ple'
                    tema='secondary'
                    className={styles.botoAltaEstacio}
                />
            </div>
            <div className={styles.contentMapa}>
                <Embed data={embed} className={styles.mapa} />
            </div>
        </div>
    );
};

export default Meteodades;
